import hibu from "./hibu.png";

export default { hibu };



// WEBPACK FOOTER //
// ./src/logos/index.js